import type { Theme } from '@mui/material';
import { Link, Typography, useTheme } from '@mui/material';

const MAXIMUM_ALLOWED_CHARACTERS_EMAIL = 30;

export const InviteLeaseDetailsSuccessToastMessage = ({ emailText }: { emailText: string }) => {
  const theme = useTheme();

  return (
    <>
      <Typography
        sx={{
          fontSize: '16px !important',
          fontWeight: 500,
        }}
      >
        Invitation sent
      </Typography>
      <Typography
        sx={{
          fontSize: '16px !important',
          color: theme.palette.neutralGrey?.[700],
          wordBreak: 'break-all',
        }}
      >
        {emailText?.length > MAXIMUM_ALLOWED_CHARACTERS_EMAIL ? '...' : ''}
        {emailText?.slice(-MAXIMUM_ALLOWED_CHARACTERS_EMAIL)}
      </Typography>
    </>
  );
};

export const InviteLeaseDetailsSuccessToastCta = ({ onClick }: { onClick: () => void }) => {
  const theme = useTheme();

  return (
    <Link
      component="button"
      color="inherit"
      underline="none"
      onClick={onClick}
      sx={{
        fontWeight: 700,
        cursor: 'pointer',
        color: theme.palette.green?.[700],
      }}
    >
      Invite another
    </Link>
  );
};

export const createInviteLeaseDetailsSuccessToastParams = ({
  emails,
  onInviteAnother,
  theme,
}: {
  emails: string[];
  onInviteAnother: () => void;
  theme: Theme;
}) => ({
  message: <InviteLeaseDetailsSuccessToastMessage emailText={emails[0] ?? ''} />,
  config: {
    sx: {
      maxWidth: '400px',
      border: `1px solid ${theme.palette.green?.[700] ?? theme.palette.success.main}`,
      '& .MuiAlert-message .MuiStack-root': {
        maxWidth: '187px',
      },

      '& .MuiAlert-action': {
        mx: 0,
        minWidth: 'fit-content !important',
      },
    },
  },
  cta: <InviteLeaseDetailsSuccessToastCta onClick={onInviteAnother} />,
});
